import {
  useRef, useState,
} from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import loadable from '@utils/loadable';
import classNames from 'classnames/bind';

import withComponentName from '../../../decorators/withComponentName';
import withRouter from '../../../decorators/withRouter';
import withMetatag from '../../../decorators/metadataDecorators/metatagsTitleDecorator';

import { SILVER } from '../../../data/permissions';
import { searchTypeListWatchlistMapping } from '../../../data/searchbar/types';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const SearchbarInner = loadable(() => import('../../SearchbarComponents/SearchbarInner'));

const OnboardingWatchlist = ({
  history,
  piwikEnabled,
  searchbarInnerRef,
  handleSearchSubmit,
  resetSearchbarValues,
}) => {
  const {
    searchBarActive,
    premUser,
    newWatchlistTopics,
    userKeywords,
  } = useSelector((state) => ({
    searchBarActive: state.searchReducers.searchBarActive,
    blurSearchbar: state.searchReducers.blur,
    premUser: state.subscriptions.permissions.access_levels.includes(SILVER),
    newWatchlistTopics: (
      state.searchReducers[
        searchTypeListWatchlistMapping[state.searchReducers.activeSearchType]
      ]
    ),
    userKeywords: state.searchReducers.userKeywords,
  }));

  const [searhBarActive, setSearhBarActive] = useState(false);

  const searchbarInnerWrapperRef = useRef(null);

  const onSearchBarActivate = (bool) => (setSearhBarActive(bool));

  const handleClickOutside = (e) => {
    if (e.target && (
      document.getElementsByClassName('manage-wl-change-name-modal')[0]?.contains(e.target)
     || document.getElementsByClassName('navigation')[0]?.contains(e.target)
     || document.getElementsByClassName('topic_user_warning_modal')[0]?.contains(e.target)
    )) {
      return;
    }

    if (
      e.target && !searhBarActive
        && searchbarInnerWrapperRef.current
        && !searchbarInnerWrapperRef.current.contains(e.target)
    ) {
      resetSearchbarValues();
      window.removeEventListener('click', handleClickOutside);
    }
  };

  const handleFilterClick = () => {
    if (!searhBarActive) {
      window.addEventListener('click', handleClickOutside);
    } else {
      window.removeEventListener('click', handleClickOutside);
    }
  };

  return (
    <div className={cx('onboarding_watchlist', { searchbar__active: searchBarActive })}>
      <div className={cx('onboarding_watchlist_wrapper', { gold: premUser })}>
        <div className={cx('onboarding_watchlist_wrapper__update-message', 'basic')}>
          <h3>Create Watchlist</h3>
          {!premUser && (
            <div className={cx('onboarding_watchlist_wrapper__update-message-text')}>
              <p>
                Search up to 5 topics to start.
              </p>
              {' '}
              <Link to="/pricing">Upgrade</Link>
              {' '}
              for more.
            </div>
          )}
        </div>
        <section
          className={cx('onboarding_searchbar', { active_search_bar: searhBarActive })}
          ref={searchbarInnerWrapperRef}
          onClick={handleFilterClick}
        >
          <SearchbarInner
            searchStyles={[
              'fixed_searchbar',
              'multiple_searchbar_fixed',
              'onboarding',
              'onboarding_page_searchbar',
            ]}
            multipleFixed
            multipleSearch
            onboarding
            inputWrapperRelative
            hasBigScreenDesign
            onboardingDisabled={!newWatchlistTopics.lenght || !userKeywords.trim()}
            history={history}
            onSearchBarActivate={onSearchBarActivate}
            onSearchSubmit={handleSearchSubmit}
            piwikEnabled={piwikEnabled}
            searchbarType="createWatchlistsSearchbar"
            ref={searchbarInnerRef}
            isWatchlist
          />
        </section>
      </div>
    </div>
  );
};

export default withComponentName(withRouter(OnboardingWatchlist));
